var jQuery = window.jQuery; // TODO: require("jquery");

var clockref;
var initial_time = 0;
var total_response_time = 1;
var container;
var intervalRef;
var updateInterval;
var timeout_callback; // timeout-callback-function
var countdown_mode; // expect boolean (thk)

function init(seconds, total_seconds, container_class_name, is_countdown) {
  initial_time = seconds;
  total_response_time = total_seconds;
  container = container_class_name;
  updateInterval = 16; // 60 fps
  countdown_mode = is_countdown;
}

function start() {
  clockref = new Date();

  reset_interval();
  intervalRef = window.setInterval(update, updateInterval);
  update();
}

function register_timeout_callback(new_timeout_callback) {
  timeout_callback = new_timeout_callback;
}

function format_time(given_seconds) {
  var minutes = Math.floor(given_seconds / 60);
  var seconds = given_seconds % 60;
  if (seconds <= 9) {
    seconds = "0"+seconds;
  }
  return minutes + ":" + seconds;
}

function update() {
  if( !clockref ) return;

  var now = new Date();
  if(countdown_mode) {
    var time = initial_time - (now.getTime()-clockref.getTime()) / 1000;

    if(time >= 0) {
      update_dom(container, time, true);
    } else {
      // we're ending the countdown now
      update_dom(container, 0);

      window.clearInterval(intervalRef);

      if( timeout_callback ) timeout_callback();
    }
  } else {
    var time_passed = initial_time + (now.getTime() - clockref.getTime()) / 1000;
    update_dom(container, time_passed, false);
  }
}

function update_dom(container, time, is_countdown) {
  var update_element = document.getElementsByClassName(container)[0];
  if( update_element ) {
    update_element.innerHTML = format_time(Math.round(time));
  }

  var percent = time / total_response_time * 100;
  if( percent > 100 ) percent = 100;
  var $progress = jQuery(".js-quiz-countdown");
  $progress.css("width", percent+"%");

  var step_width = 25;
  var rounded_percent;
  if( is_countdown ) {
    rounded_percent = (Math.floor(percent / step_width) + 1) * step_width;
  } else {
    rounded_percent = (Math.floor(percent / step_width)) * step_width;
  }
  if( rounded_percent > 100 ) rounded_percent = 100;

  var rounded_percent_modifier_progress;
  var rounded_percent_modifier_time;
  if( is_countdown ) {
    rounded_percent_modifier_progress = "progress__inner--below-"+rounded_percent;
    rounded_percent_modifier_time = "time-counter--below-"+rounded_percent;
  } else {
    rounded_percent_modifier_progress = "progress__inner--over-"+rounded_percent;
    rounded_percent_modifier_time = "time-counter--over-"+rounded_percent;
  }

  var $time_counter = jQuery(".js-neoquiz-clock-timer");

  if( !$progress.hasClass(rounded_percent_modifier_progress) ) {
    $progress.addClass(rounded_percent_modifier_progress);
  }
  if( !$time_counter.hasClass(rounded_percent_modifier_time) ) {
    $time_counter.addClass(rounded_percent_modifier_time);
  }
}

function reset_interval() {
  if( intervalRef ) clearInterval(intervalRef);
}

function timeout(redirect_url) {
  jQuery.pjax({url: redirect_url, container: '.js-neo-pjax-content'});
}

//
// DOM init
//
jQuery(function($) {
  $(".neo").on("click", "[data-reset-quiz-clock]", function() {
    reset_interval();
  });
});

exports.init = init;
exports.start = start;
exports.timeout = timeout;
exports.register_timeout_callback = register_timeout_callback;
